import { render, staticRenderFns } from "./Xyr.vue?vue&type=template&id=68b8141b&scoped=true&"
import script from "./Xyr.vue?vue&type=script&lang=js&"
export * from "./Xyr.vue?vue&type=script&lang=js&"
import style0 from "./Xyr.vue?vue&type=style&index=0&id=68b8141b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8141b",
  null
  
)

export default component.exports